module.exports = __webpack_public_path__ + "img/overtime.e691197e.jpg";